var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticStyle:{"display":"none"},attrs:{"id":"ad-closed"},on:{"click":_vm.adClosed}}),_c('button',{staticStyle:{"display":"none"},attrs:{"id":"ad-success"},on:{"click":_vm.adSuccess}})])}
var staticRenderFns = []

export { render, staticRenderFns }